<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">{{title}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div class="w-100 d-flex justify-content-center align-items-center">
  <div class="camera-wrapper">
    <label *ngIf="!showImage" for="cameraSelect">Selecciona cámara:</label>
    <select *ngIf="!showImage" id="cameraSelect" (change)="onDeviceChange($event)">
      <option *ngFor="let device of devices" [value]="device.deviceId">
        {{ device.label || 'Cámara ' + device.deviceId }}
      </option>
    </select>

    <video *ngIf="!showImage" #videoElement autoplay muted></video>

    <button *ngIf="!showImage" class="btn btn-primary" (click)="captureImage()">Capturar imagen</button>

    <canvas #canvasElement style="display: none;"></canvas>

    <div *ngIf="showImage">
      <h4>Imagen capturada:</h4>
      <img [src]="capturedImage" alt="captura" />
      <div class="d-flex flex-row align-items-center justify-content-end w-100 mt-2">
        <button class="btn btn-warning w-100" (click)="reintentar()">Tomar otra vez.</button>
        <button class="btn btn-primary ms-2 w-100" (click)="continuar()">Guardar</button>
      </div>
    </div>
  </div>
</div>
